import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import type { TimesheetDeadlineSettings } from '@/types/timesheetSettings';
import { getDayName } from '@/types/timesheetSettings';

interface TimesheetReminderSettingsProps {
  settings: TimesheetDeadlineSettings;
  onChange: (settings: TimesheetDeadlineSettings, isValid: boolean) => void;
}

export const TimesheetReminderSettings: React.FC<TimesheetReminderSettingsProps> = ({
  settings,
  onChange,
}) => {
  const handleSendRemindersChange = (checked: boolean) => {
    const newSettings = {
      ...settings,
      sendReminders: checked,
    };
    onChange(newSettings, true);
  };

  // Format deadline time for display (e.g., "17:00" -> "5:00 PM")
  const formatTime = (time: string): string => {
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  const deadlineDay = getDayName(settings.deadlineDay);
  const deadlineTime = formatTime(settings.deadlineTime);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Submission Reminders</CardTitle>

      </CardHeader>
      <CardContent className="space-y-4">
        
        {/* Submission Deadline Feed Reminders */}
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="sendReminders">Submission Deadline Reminders</Label>
            <p className="text-sm text-muted-foreground">
              Enable feed notifications {settings.reminderDaysBefore} {settings.reminderDaysBefore === 1 ? 'day' : 'days'} before the {deadlineDay} deadline at {deadlineTime}
            </p>
          </div>
          <Switch
            id="sendReminders"
            checked={settings.sendReminders}
            onCheckedChange={handleSendRemindersChange}
          />
        </div>

      </CardContent>
    </Card>
  );
};
